// import {recommendListLoad, slideImageLoad} from '../../../../api/xs/config.js'
import { latestWZApp } from '../../../../api/g/wzapp'
import { homeModulesLoad } from '../../../../api/xs/config.js'
import { CORP_XS } from '../../../../const'
import { saveXSAppInfo } from '../../../../common/wzapp'

export default {
  // 检测 XSApp 信息
  async checkXSApp({ state, getters }, forceUpdate) {
    if (forceUpdate || getters.needCheckXSApp) {
      const { info } = await latestWZApp({ corp: CORP_XS })
      // TODO: 保存至 localStorage
      const data = saveXSAppInfo(info)
      state._latestAppInfo = data
      return data
    }

    return null
  },

  async loadHomeModules({ state }) {
    // const pageKey = getters.homePageKey || 'web.xsHome'
    const pageKey = 'web.xsHome'
    const { list } = await homeModulesLoad({ pageKey })
    state.homeModules = list || []
    return { list }
  }
}
